export default {
  nav: {
    hotels: 'Hotels',
    flights: 'Flights',
    localFlights: 'Local Flights',
    taxi: 'Taxi',
    packages: 'Packages',
    aiBooking: 'AI Booking',
    hajjUmrah: 'Hajj/Umrah',
    signIn: 'Sign in',
    signUp: 'Sign up',
  },

  // Header Navigation
  'nav.hotels': 'Hotels',
  'nav.flights': 'Flights',
  'nav.taxi': 'Taxi',
  'nav.packages': 'Packages',
  'nav.aiBooking': 'AI Booking',
  'nav.hajjUmrah': 'Hajj/Umrah',
  'nav.signIn': 'Sign in',
  'nav.language': 'English (US)',
  'nav.currency': 'USD',
  
  // Sign In Modal
  'signIn.title': 'Sign in to Rigland Travels Ltd',
  'signIn.email': 'Email',
  'signIn.password': 'Password',
  'signIn.emailPlaceholder': 'Enter your email',
  'signIn.passwordPlaceholder': 'Enter your password',
  'signIn.button': 'Sign in',
  'signIn.noAccount': "Don't have an account?",
  'signIn.createOne': 'Create one',
  
  // Search Widget
  'search.hotels': 'Hotels',
  'search.flights': 'Flights',
  'search.taxi': 'Taxi',
  'search.packages': 'Packages',
  'search.aiBooking': 'AI Booking',
  'search.hajjUmrah': 'Hajj/Umrah',
  'search.destination': 'Where are you going?',
  'search.checkIn': 'Check-in',
  'search.checkOut': 'Check-out',
  'search.guests': 'Guests',
  'search.searchButton': 'Search',
  'search.from': 'From',
  'search.to': 'To',
  'search.departure': 'Departure',
  'search.return': 'Return',
  'search.passengers': 'Passengers',
  'search.pickUp': 'Pick-up location',
  'search.dropOff': 'Drop-off location',
  'search.pickUpDate': 'Pick-up date',
  'search.dropOffDate': 'Drop-off date',
  'search.packageType': 'Package type',
  'search.activity': 'What do you want to do?',
  'search.date': 'Date',
  'search.departureDate': 'Departure date',
  'search.returnDate': 'Return date',
  'search.pilgrims': 'Pilgrims',
  
  // Home Page
  'home.hero.title': 'Your Journey Begins Here',
  'home.hero.subtitle': 'Discover amazing destinations, book flights, hotels, and create unforgettable memories with Rigland Travels Ltd',
  'home.popularDestinations': 'Popular Destinations',
  'home.exploreWorld': 'Explore the World',
  'home.whyChooseUs': 'Why Choose Rigland Travels Ltd',
  'home.bestPrices': 'Best Prices',
  'home.bestPricesDesc': 'We guarantee the best prices for all your travel needs',
  'home.support': '24/7 Support',
  'home.supportDesc': 'Our team is always available to assist you',
  'home.easyBooking': 'Easy Booking',
  'home.easyBookingDesc': 'Book your travel in just a few clicks',
  'home.trustedPartner': 'Trusted Partner',
  'home.trustedPartnerDesc': 'Over 10 years of excellence in travel services',
  
  // Hotels Page
  'hotels.title': 'Find Your Perfect Stay',
  'hotels.subtitle': 'Discover comfortable hotels in Kaduna and beyond',
  'hotels.featured': 'Featured Hotels in Kaduna',
  'hotels.categories': 'Hotel Categories',
  'hotels.luxury': 'Luxury Hotels',
  'hotels.business': 'Business Hotels',
  'hotels.budget': 'Budget Hotels',
  'hotels.perNight': 'per night',
  'hotels.viewDetails': 'View Details',
  'hotels.rooms': 'Rooms',
  'hotels.adults': 'Adults',
  'hotels.children': 'Children',
  
  // Flights Page
  'flights.title': 'Book Your Flight',
  'flights.subtitle': 'Find the best flights to your destination',
  'flights.roundTrip': 'Round-trip',
  'flights.oneWay': 'One-way',
  'flights.multiCity': 'Multi-city',
  'flights.popularRoutes': 'Popular Routes from Kaduna',
  'flights.ourPartners': 'Our Partner Airlines',
  'flights.economy': 'Economy',
  'flights.premiumEconomy': 'Premium Economy',
  'flights.business': 'Business',
  'flights.firstClass': 'First Class',
  'flights.infants': 'Infants',
  
  // Taxi Page
  'taxi.title': 'Book Your Taxi',
  'taxi.subtitle': 'Reliable taxi services to your destination',
  'taxi.categories': 'Taxi Categories',
  'taxi.economy': 'Economy',
  'taxi.standard': 'Standard',
  'taxi.suv': 'SUV',
  'taxi.executive': 'Executive',
  'taxi.serviceAreas': 'Service Areas in Kaduna',
  'taxi.features': 'Our Taxi Services',
  'taxi.professionalDrivers': 'Professional Drivers',
  'taxi.professionalDriversDesc': 'Experienced and courteous drivers',
  'taxi.safetyFirst': 'Safety First',
  'taxi.safetyFirstDesc': 'Well-maintained vehicles with insurance',
  'taxi.affordablePrices': 'Affordable Prices',
  'taxi.affordablePricesDesc': 'Transparent pricing with no hidden fees',
  'taxi.support': '24/7 Availability',
  'taxi.supportDesc': 'Book anytime, anywhere',
  
  // Packages Page
  'packages.title': 'Travel Packages',
  'packages.subtitle': 'Discover our curated travel packages for unforgettable experiences',
  'packages.categories': 'Package Categories',
  'packages.flightHotel': 'Flight + Hotel',
  'packages.hajjUmrah': 'Hajj & Umrah',
  'packages.allInclusive': 'All-Inclusive',
  'packages.familyPackages': 'Family Packages',
  'packages.honeymoon': 'Honeymoon',
  'packages.adventure': 'Adventure',
  'packages.vacation': 'Vacation Packages',
  'packages.specialDeals': 'Special Deals',
  'packages.perPerson': 'per person',
  'packages.days': 'days',
  'packages.bookNow': 'Book Now',
  'packages.save': 'Save',
  
  // AI Booking Page
  'aiBooking.title': 'AI-Powered Booking Assistant',
  'aiBooking.subtitle': 'Book your entire trip just by chatting with our AI assistant',
  'aiBooking.heroTitle': 'Book Flights with AI',
  'aiBooking.heroSubtitle': 'Simply tell us where you want to go, and our AI will handle everything',
  'aiBooking.placeholder': 'Type your travel request... e.g., "I want to fly from Lagos to London next week"',
  'aiBooking.send': 'Send',
  'aiBooking.examples': 'Try asking:',
  'aiBooking.example1': 'Book a flight from Abuja to Dubai for 2 passengers',
  'aiBooking.example2': 'I need a round trip to London leaving next Monday',
  'aiBooking.example3': 'Find me the cheapest flight to New York in December',
  'aiBooking.example4': 'Business class tickets to Paris for my family',
  'aiBooking.howItWorks': 'How It Works',
  'aiBooking.step1': 'Chat with AI',
  'aiBooking.step1Desc': 'Tell our AI assistant where you want to go',
  'aiBooking.step2': 'Get Options',
  'aiBooking.step2Desc': 'AI searches and presents the best flight options',
  'aiBooking.step3': 'Refine Search',
  'aiBooking.step3Desc': 'Ask questions and adjust your preferences',
  'aiBooking.step4': 'Complete Booking',
  'aiBooking.step4Desc': 'Confirm and pay - all through chat',
  'aiBooking.features': 'Why Use AI Booking',
  'aiBooking.natural': 'Natural Conversation',
  'aiBooking.naturalDesc': 'Book flights the way you talk',
  'aiBooking.smart': 'Smart Suggestions',
  'aiBooking.smartDesc': 'AI recommends the best options for you',
  'aiBooking.fast': 'Lightning Fast',
  'aiBooking.fastDesc': 'Complete bookings in minutes',
  'aiBooking.support': '24/7 Available',
  'aiBooking.supportDesc': 'AI assistant always ready to help',
  'aiBooking.startChat': 'Start chatting to book your flight...',
  
  // Hajj/Umrah Page
  'hajj.title': 'Hajj & Umrah Packages',
  'hajj.subtitle': 'Fulfill your spiritual journey with our comprehensive packages',
  'hajj.packages': 'Hajj Packages',
  'hajj.umrahPackages': 'Umrah Packages',
  'hajj.premium': 'Premium',
  'hajj.standard': 'Standard',
  'hajj.luxury': 'Luxury',
  'hajj.economy': 'Economy',
  'hajj.days': 'days',
  'hajj.perPerson': 'per person',
  'hajj.bookNow': 'Book Now',
  'hajj.includes': 'Package Includes',
  'hajj.flights': 'Return flights from Kaduna',
  'hajj.accommodation': 'Accommodation in Makkah & Madinah',
  'hajj.meals': 'Daily meals',
  'hajj.transport': 'Ground transportation',
  'hajj.guidance': 'Religious guidance',
  'hajj.visa': 'Visa processing',
  'hajj.additionalServices': 'Additional Services',
  'hajj.visaService': 'Visa Assistance',
  'hajj.visaServiceDesc': 'Complete visa processing support',
  'hajj.insurance': 'Travel Insurance',
  'hajj.insuranceDesc': 'Comprehensive coverage for peace of mind',
  'hajj.ziyarat': 'Ziyarat Tours',
  'hajj.ziyaratDesc': 'Guided tours to historical Islamic sites',
  'hajj.religiousGuides': 'Religious Guides',
  'hajj.religiousGuidesDesc': 'Expert scholars to guide your journey',
  'hajj.ourGuides': 'Our Expert Religious Guides',
  'hajj.yearsExperience': 'years experience',
  
  // Footer
  'footer.about': 'About Rigland Travels Ltd',
  'footer.aboutDesc': 'Your trusted partner for all travel needs in Nigeria and beyond. We provide exceptional service for hotels, flights, taxi services, packages, and Hajj/Umrah pilgrimages.',
  'footer.quickLinks': 'Quick Links',
  'footer.services': 'Services',
  'footer.contact': 'Contact Us',
  'footer.phone': 'Phone',
  'footer.email': 'Email',
  'footer.address': 'Address',
  'footer.followUs': 'Follow Us',
  'footer.newsletter': 'Subscribe to Our Newsletter',
  'footer.newsletterDesc': 'Get the latest travel deals and updates',
  'footer.emailPlaceholder': 'Enter your email',
  'footer.subscribe': 'Subscribe',
  'footer.rights': 'All rights reserved',
  'footer.privacy': 'Privacy Policy',
  'footer.terms': 'Terms of Service',
  
  // General Page
  'general.title': 'Discover Amazing Destinations',
  'general.subtitle': 'Explore the world with our curated travel destinations and experiences',
  'general.searchDestinations': 'Search destinations...',
  'general.allRegions': 'All Regions',
  'general.allBudgets': 'All Budgets',
  'general.popularDestinations': 'Popular Destinations',
  'general.results': 'results',
  'general.noResults': 'No destinations found',
  'general.tryDifferentSearch': 'Try adjusting your search criteria',

  // Common
  'common.loading': 'Loading...',
  'common.error': 'Error',
  'common.success': 'Success',
  'common.cancel': 'Cancel',
  'common.confirm': 'Confirm',
  'common.close': 'Close',
  'common.save': 'Save',
  'common.edit': 'Edit',
  'common.delete': 'Delete',
  'common.viewMore': 'View More',
  'common.learnMore': 'Learn More',
};

export const en = {
  auth: {
    signIn: 'Sign In',
    signUp: 'Sign Up',
    signInSubtitle: 'Welcome back! Please sign in to your account',
    signUpSubtitle: 'Create your account to start booking amazing trips',
    signInWithGoogle: 'Continue with Google',
    signUpWithGoogle: 'Sign up with Google',
    orContinueWith: 'or continue with email',
    firstName: 'First Name',
    lastName: 'Last Name',
    phoneNumber: 'Phone Number',
    emailAddress: 'Email Address',
    password: 'Password',
    createAccount: 'Create Account',
    processing: 'Processing...',
    agreeToTerms: 'I agree to the',
    termsOfService: 'Terms of Service',
    and: 'and',
    privacyPolicy: 'Privacy Policy',
    noAccount: "Don't have an account?",
    haveAccount: 'Already have an account?',
    forgotPassword: 'Forgot your password?',
    registrationSuccess: 'Registration Successful!',
    registrationSuccessMessage: 'Your account has been created successfully.',
    signinSuccess: 'Welcome Back!',
    signinSuccessMessage: 'You have been signed in successfully.'
  }
};